module.exports = __webpack_public_path__ + "2d7d2aa5624a5c6aac665189e03f3009.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/monster_energy_company_2023_chart.png
// module id = 1700
// module chunks = 0